export const QUESTIONNAIRE = [
    {
        key: 'problem',
        prompt: 'What problem does your product solve?',
        help: 'Describe the pain point and who feels it.',
        required: true,
    },
    {
        key: 'users',
        prompt: 'Who are your users?',
        help: 'The people who will actually use the MVP.',
        required: true,
    },
    {
        key: 'core_features',
        prompt: 'What must a user be able to do?',
        help: 'The handful of core actions the MVP cannot ship without.',
        required: true,
    },
    {
        key: 'success',
        prompt: 'What does success look like?',
        help: 'How you will know the MVP is working.',
        required: true,
    },
    {
        key: 'integrations',
        prompt: 'Any systems it must integrate with?',
        help: 'Payment, email, existing tools, third-party APIs — or none.',
        required: false,
    },
    {
        key: 'non_functional',
        prompt: 'Any security, scale, or compliance needs?',
        help: 'For example expected load, sensitive data, or regulations that apply.',
        required: false,
    },
    {
        key: 'timeline',
        prompt: 'Ideal time to market?',
        help: 'A rough target is fine.',
        required: false,
    },
    {
        key: 'branding',
        prompt: 'Any branding or design preferences?',
        help: 'Colours, tone, references — or leave it to us.',
        required: false,
    },
];
const QUESTION_KEYS = new Set(QUESTIONNAIRE.map((question) => question.key));
export function isQuestionKey(key) {
    return QUESTION_KEYS.has(key);
}
/** The keys whose answers are required before a spec can be generated. */
export const REQUIRED_QUESTION_KEYS = QUESTIONNAIRE.filter((question) => question.required).map((question) => question.key);
//# sourceMappingURL=questionnaire.js.map